export default __webpack_public_path__ + "static/media/Tahitiana.13e99364.png";